var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "-409 211 140 140"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-339 211c-38.7 0-70 31.3-70 70s31.3 70 70 70 70-31.3 70-70-31.3-70-70-70zm-34.3 53.7c-2.8-1.5-2.5-3.2.6-3.7l65-10.6c3.2-.5 4.8-.2 5.2.7 0 0-35 21.7-44.8 27.5l-26-13.9zm70.3-6.8l-38.7 53.3c-1.9 2.6-3.5 2.1-3.6-1.1l-.7-29.5c9.6-6.1 44.7-27.6 44.7-27.7.7.8.2 2.4-1.7 5z",
    fill: "#304256"
  })));
}

export default SvgSend;